import { RootState } from 'modules/main/redux';

import { Plan, PLAN_HIERARCHY } from 'modules/subscription';
import { User } from '../types';

const userData = (state: RootState): User | null => state.user.data;

const hasLoaded = (state: RootState): boolean => !!state.user.hasLoaded;

const userPlan = (state: RootState): string =>
  state.user.data?.subscription ?? Plan.Free;

const userPlanTier = (state: RootState): Plan => {
  const [tier] = (state.user.data?.subscription ?? '').split('_');
  return tier in PLAN_HIERARCHY ? (tier as Plan) : Plan.Free;
};

const subscriptionEndsAt = (state: RootState): string | null =>
  state.user.data?.subscriptionEndsAt ?? null;

const featureFlags = (state: RootState): Record<string, boolean> =>
  state.user.data?.featureFlags ?? {};

export const UserSelectors = {
  userData,
  hasLoaded,
  userPlan,
  userPlanTier,
  subscriptionEndsAt,
  featureFlags,
};
